<template>
  <div :style="{width,height}" class="flex-row-center items-center relative">
    <i class="flex-row loading-logo" :style="{width: loadingSize,height: loadingSize}">
      <!-- <svg
        :width="`${radius * 2 + strokeWidth}px`"
        :height="`${radius * 2 + strokeWidth}px`"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="50%" cy="50%" :r="radius" :stroke-width="strokeWidth" stroke="#E4E7EC" fill="none" />
        <circle cx="50%" cy="50%" :r="radius" :stroke-width="strokeWidth" stroke="#2A64FB" fill="none" class="circle-svg" />
      </svg> -->
    </i>
    <!-- <i class="flex-row loading-gif" /> -->
    <div v-if="loadingText" class="text-md-m gray-900 absolute loading-text">{{ loadingText }}</div>
  </div>
</template>
<script lang="ts" setup>

defineProps({
  width: {
    type: String,
    default: '100px'
  },
  height: {
    type: String,
    default: '100px'
  },
  loadingSize: {
    type: String,
    default: '32px'
  },
  radius: {
    type: Number,
    default: 14
  },
  strokeWidth: {
    type: Number,
    default: 2
  },
  loadingText: {
    type: String,
    default: ''
  }
});
</script>

<style lang="scss" scoped>
.loading-text {
  bottom: -5px;
}
.loading-gif {
  position: relative;
  width: 50px;
  height: 50px;
  background: url('@/assets/img/spot/loading.gif') no-repeat center/100% 100%;
}
.loading-logo {
  position: relative;
  width: 32px;
  height: 32px;
  background: url(@/assets/img/hk-spot/loading-icon.png) center/cover no-repeat;
  animation: rotateZ 1s linear infinite;

  // svg {
  //   flex-shrink: 0;
  //   animation: rotateZ 3s linear infinite;
  // }

  // .circle-svg {
  //   stroke-dasharray: 60 500;
  //   animation: circle 2.5s ease-in-out infinite;
  // }

  // &::before {
  //   content: '';
  //   display: inline-block;
  //   position: absolute;
  //   left: 7px;
  //   top: 7px;
  //   right: 7px;
  //   bottom: 7px;
  //   background: url('@/assets/img/svg/loading-logo.svg') no-repeat center/100% 100%;
  // }
}

@keyframes rotateZ {
  100% {
    transform: rotateZ(360deg);
  }
}

@keyframes circle {
  0% {
    stroke-dasharray: 0 500;
  }
  50% {
    stroke-dasharray: 60 500;
  }
  100% {
    stroke-dasharray: 100 500;
  }
}
</style>
